import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QuantitySelector, Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
const PDP_QUANTITY_SELECTOR = 'pdp-quantity';
export const ProductQuantity = ({ quantity, setQuantity }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsxs(Stack, { direction: "col", gap: "2", children: [_jsx(TextAlpha, { strong: true, children: t('pdp.quantity') }), _jsx(QuantitySelector, { testId: PDP_QUANTITY_SELECTOR, quantity: quantity, min: 1, onUpdate: setQuantity })] }));
};
